// SPDX-License-Identifier: AGPL-3.0-or-later

// The reader's locale, then another region of the same language, then the default text.
export function pickLocalizedText(
	text: string | null,
	localizations: Readonly<Record<string, string>> | null | undefined,
	locale: string,
): string | null {
	if (!localizations) return text;
	const exact = localizations[locale];
	if (exact) return exact;
	const language = locale.split('-')[0];
	const sameLanguage = Object.keys(localizations).find((key) => key.split('-')[0] === language);
	return sameLanguage ? localizations[sameLanguage] : text;
}
